import {
  Grid,
  IconButton,
  Link,
  Typography,
  ContentCopyIcon,
} from '@gogame/components';

export const TrackingLinksListItem = ({
  option,
  style,
  className,
  onCopyLink,
}) => {
  return (
    <Grid
      style={style}
      className={className}
      container
      wrap={'nowrap'}
      alignItems={'center'}
    >
      <Grid item xs>
        <Link href={option.url} target={'_blank'}>
          <Typography variant={'body2'}>{option.name}</Typography>
        </Link>
      </Grid>
      <Grid item>
        <IconButton
          icon={<ContentCopyIcon />}
          tooltip={'Copy name'}
          onClick={() => onCopyLink(option.url)}
        />
      </Grid>
    </Grid>
  );
};
